<button (click)="sendPatientRequest()" mat-raised-button color="primary">
  Anfrage erstellen
</button>
